import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { store } from 'App';
import { ImageConstantType } from 'common/ImageConstants';
import { useCurrentThemeType } from 'common/theme';
import { getAssetPath } from 'common/utilities/AssetsPath';
import { AnyAction } from 'redux';

export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, unknown, AnyAction>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Will always return a themed image for a given image name
 * @param imageName
 * @returns {string} Themed image path
 */
export const useAssetPath = (imageName: ImageConstantType): string => {
  const theme = useCurrentThemeType();
  return getAssetPath(imageName, theme);
};

/**
 * Will always return themed images for a given image name
 * @param imageNames
 * @returns {string} Themed image path
 */
export const useAssetsPath = (imageNames: ImageConstantType[]) => {
  const theme = useCurrentThemeType();
  return imageNames.map((imageName) => getAssetPath(imageName, theme));
};
